module.exports = __webpack_public_path__ + "img/income-fixed.5b41a9d2.png";